import React, { useState } from "react";
import Label from "./Common/Label";
import RowContainer from "./Common/RowContainer";
import Container from "./Common/Container";
import editIcon from "../assets/editIcon.svg";
import deleteIcon from "../assets/deleteIcon.svg";
import copyIcon from "../assets/copyIcon.svg";
import styled from "styled-components";
import Switch from "./Common/Switch";
import { useResponsiveFlex } from "../utils/useResponsiveFlex";

interface Question {
  id: number;
  question: string;
  level: string;
  latestdate: string;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onCheckboxChange: (id: number) => void;
  isChecked: boolean;
  status: boolean;
  onStatusChange: (id: number) => void;
  onCopy: (id: number) => void;
}

const NewRowContainer = styled(RowContainer)`
  overflow: hidden;
`;

const NewLabel = styled(Label)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const Questions: React.FC<Question> = ({
  id,
  question,
  level,
  latestdate,
  onEdit,
  onDelete,
  onCheckboxChange,
  isChecked,
  status,
  onStatusChange,
  onCopy,
}) => {
  const [isSwitchOn, setIsSwitchOn] = useState(status);
  const flex = useResponsiveFlex();

  const toggleStatus = () => {
    const newStatus = !isSwitchOn;
    setIsSwitchOn(newStatus);
    onStatusChange(id);
  };

  const handleDelete = () => {
    onDelete(id);
  };

  return (
    <Container
      bgColor={isChecked ? "#f0ebff" : "#fff"}
      borderRadius="10px"
      height="50px"
      alignItems="center"
      display="flex"
      width="100%"
      className="user-data user-container-hover"
      style={{ outline: isChecked ? "2px solid #7542E4" : "none" }}
    >
      <RowContainer
        justifyContent="space-between"
        alignItem="center"
        borderRadius="12px"
        margin="10px"
      >
        {/* Checkbox */}
        <RowContainer flex="1.4" alignItem="center">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => onCheckboxChange(id)}
            onClick={(e) => e.stopPropagation()}
            style={{
              width: 16,
              height: 16,
              accentColor: "#7542E4",
              cursor: "pointer",
            }}
          />
        </RowContainer>

        <NewRowContainer flex={flex.questionsName} gap="0px">
          <NewLabel fontSize="16px" fontWeight={400}>
            {question}
          </NewLabel>
        </NewRowContainer>

        <NewRowContainer flex="4.5" gap="0px">
          <NewLabel fontSize="16px" fontWeight={400}>
            {level}
          </NewLabel>
        </NewRowContainer>

        <NewRowContainer flex="5.5" gap="0px">
          <NewLabel fontSize="16px" fontWeight={400}>
            {latestdate}
          </NewLabel>
        </NewRowContainer>

        <RowContainer flex={flex.questionsAction} gap="0px">
          <div
            className="d-flex align-items-center"
            style={{ gap: "10px" }}
          >
            <Switch isOn={isSwitchOn} onToggle={toggleStatus} />
            <div
              style={{ cursor: "pointer" }}
              onClick={() => onCopy(id)}
              title="Clone question"
            >
              <img
                src={copyIcon}
                className="user-scale"
                alt="Copy"
                style={{ WebkitUserSelect: "none", userSelect: "none" }}
              />
            </div>
            <div style={{ cursor: "pointer" }}>
              <img
                src={editIcon}
                onClick={() => onEdit(id)}
                className="user-scale"
                alt="Edit"
                style={{ WebkitUserSelect: "none", userSelect: "none" }}
              />
            </div>
            <div style={{ cursor: "pointer" }} onClick={handleDelete}>
              <img
                src={deleteIcon}
                alt="Delete"
                style={{ WebkitUserSelect: "none", userSelect: "none" }}
              />
            </div>
          </div>
        </RowContainer>
      </RowContainer>
    </Container>
  );
};
export default Questions;
